import React from "react";
import CustomEmptyState from "../../../../ui/CustomEmptyState/CustomEmptyState";

const UserEmptyState = ({
  noUsers,
  noResults,
  emptyStateMessage,
  emptyStateSubMessage,
}) => {
  if (noUsers) {
    return (
      <CustomEmptyState
        height={300}
        primary={emptyStateMessage}
        secondary={emptyStateSubMessage}
      />
    );
  }

  if (noResults) {
    return (
      <CustomEmptyState
        height={200}
        primary="No Users match your search."
        secondary="Try a different search term or clear your search to see all users."
      />
    );
  }

  return null;
};

export default UserEmptyState;
